var $3503155bf2ab897a$exports = {};
$3503155bf2ab897a$exports = {
    "replaceMessage": `Ispustite datoteku za zamjenu`
};


export {$3503155bf2ab897a$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
